import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import "./index.css";
import PaginationComponent from "../../../../../components/_utils/PaginationComponent";
import PrimaryButton from "../../../../../components/_utils/CommonButtons/PrimaryButton";
import BeneTransactionMultiApprovalCard from "../../../../../components/Transactions/BeneTrasnaction/BeneTransactionMultiApprovalCard";
import { GlobalConfiguration } from "../../../../../utils/configurationProvider";
import { BeneTxnRequireApprovalPage } from "../../../../../redux/features/beneficiary/beneTxnViewAccData/beneTxnViewAccData";
import { beneCategories } from "../../../../../redux/features/beneficiary/beneAllVerification/beneAllVerification";
import {
  disableSwitcher,
  enableSwitcher,
} from "../../../../../redux/features/multiEntitySwitcher/multiEntitySwitcher";
import BeneAccountDetailsPopup from "../../../../../components/Accounts/BeneAccount/BeneAccountDetailsPopup";
import BeneTransactionDetailsPopup from "../../../../../components/Transactions/BeneTrasnaction/BeneTransactionDetailsPopup";
import TopNavComponent from "../../../../../components/_utils/CommonTopNav/TopNavComponent";
import ICONS from "../../../../../assets/Icons";
import Loader from "../../../../../components/Loader/Index";

const BeneficiaryTransactionMultiSelect = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const filterRef = useRef(null);
  const filterRefPagination = useRef(null);

  const [page, setPage] = useState(1);
  const [label, setlabel] = useState("");
  const [active, setActive] = useState("");
  const [txnId, setTxnId] = useState(null);
  const [labels, setLabels] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [mainData, setMainData] = useState([]);
  const [pageSize, setPageSize] = useState(50);
  const [txnlabels, settxnLabels] = useState([]);
  const [inputData, setInputData] = useState([]);
  const [totalAmount, setTotalAmount] = useState(0);
  const [allAccounts, setAllAccounts] = useState([]);
  const [filterOpen, setFilterOpen] = useState(false);
  const [showSearch, setShowSearch] = useState(false);
  const [initCategory, setInitCategory] = useState("");
  const [filteredData, setfilteredData] = useState([]);
  const [loadingData, setLoadingData] = useState(false);
  const [selectedValue, setSelectedValue] = useState(50);
  const [isDrawerOpen, setisDrawerOpen] = useState(false);
  const [selectedLabels, setSelectedLabels] = useState([]);
  const [selectAllCard, setselectAllCard] = useState(false);
  const [currentCategory, setCurrentCategory] = useState("");
  const [LabelSearchText, setLabelSearchText] = useState([]);
  const [approvedAccounts, setApprovedAccounts] = useState([]);
  const [BeneTxnDetailsId, SetBeneTxnDetailsId] = useState("");
  const [beneAccountStatus, setBeneAccountStatus] = useState("");
  const [showTxnDetailPop, setShowTxnDetailPop] = useState(false);
  const [dropdownOptions, setDropdownOptions] = useState([50, 100]);
  const [showInnerSearchBar, setShowInnerSearchBar] = useState(false);
  const [allBeneTxnAccountsLoading, setAllBeneTxnAccountsLoading] =
    useState(false);
  const [selectedTransactions, setSelectedTransactions] = useState([]);
  const [ShowFilterErrorPage, setShowFilterErrorPage] = useState(false);
  const [searchUserTextDebounce, setSearchUserTextDebounce] = useState("");
  const [selectedSendTransactions, setSelectedSendTransactions] = useState([]);

  const { markerData } = useSelector((s) => s.multiEntitySwitcherSlice);

  const shouldShowPagination =
    !allBeneTxnAccountsLoading &&
    mainData &&
    mainData.total_count > GlobalConfiguration?.lengthCheckZero &&
    allAccounts.length > GlobalConfiguration?.lengthCheckZero;

  const isFilterApplied =
    !!currentCategory?.length || !!LabelSearchText?.length;

  const hasNoData =
    !allAccounts || allAccounts.length === GlobalConfiguration?.lengthCheckZero;
  const shouldShowEmptyState = !allBeneTxnAccountsLoading && hasNoData;

  const openBeneTxnDetailModal = () => {
    setShowTxnDetailPop(true);
  };
  const closeBeneTxnDetailModal = () => {
    setShowTxnDetailPop(false);
  };
  const closeBeneAccountDetailModal = () => {
    setisDrawerOpen(false);
  };

  const handleSearch = (text) => {
    setSearchUserTextDebounce(text);
  };

  const refreshBeneList = async () => {
    setAllBeneTxnAccountsLoading(true);
    setPage(1);
    setAllAccounts([]);

    await dispatch(
      BeneTxnRequireApprovalPage({
        page_no: GlobalConfiguration?.lengthCheckOne,
        page_size: pageSize,
        category: currentCategory || undefined,
        labels: LabelSearchText,
      }),
    );

    setAllBeneTxnAccountsLoading(false);
  };

  const handleFilterCategory = () => {
    setCurrentCategory(label);
    setAllAccounts([]);
    setLabelSearchText(selectedLabels);

    if (page === 1) {
      setAllBeneTxnAccountsLoading(true);
    }
    setInitCategory(false);
    setFilterOpen(false);
  };

  const handleClearParams = () => {
    setlabel("");
    setLabelSearchText("");
    setCurrentCategory("");
    setInitCategory("");
    setAllBeneTxnAccountsLoading(true);
    setPage(1);
    if (label !== "") {
      dispatch(
        BeneTxnRequireApprovalPage({
          page_no: page,
          page_size: pageSize,
          category: undefined,
        }),
      ).then((response) => {
        setAllAccounts(response?.payload?.transactions);
        setAllBeneTxnAccountsLoading(false);
        setMainData(response?.payload);
        setShowFilterErrorPage(false);
        const approved = response?.payload?.transactions.filter(
          (account) =>
            account.beneficiary_account_approval_status === "approved",
        );
        setApprovedAccounts(approved);
      });
    }
  };

  const handleSelectAll = (tt) => {
    const alreadySelectedCount = selectedTransactions?.length;
    const remainingSelections = 20 - alreadySelectedCount;
    if (tt) {
      let x = [];
      approvedAccounts.map((itm) => {
        if (selectedTransactions.includes(itm.txn_id)) {
          x.push(itm.txn_id);
        }
      });
      let y = selectedTransactions.filter((it) => !x.includes(it));
      let z = selectedSendTransactions.filter((itm) => !x.includes(itm.txn_id));
      setSelectedTransactions(y);
      setSelectedSendTransactions(z);
      let amt = z.reduce((sum, account) => sum + Number(account.amount), 0);
      setTotalAmount(amt);
    } else if (
      label === "" &&
      remainingSelections === GlobalConfiguration?.lengthCheckZero
    ) {
      setSelectedTransactions([]);
      setSelectedSendTransactions([]);
      setTotalAmount(0);
    } else {
      if (remainingSelections > GlobalConfiguration?.lengthCheckZero) {
        const newSelections = allAccounts
          .filter(
            (account) =>
              account.beneficiary_account_approval_status === "approved" &&
              !selectedTransactions.includes(account.txn_id),
          )
          .slice(0, remainingSelections)
          .map((account) => account.txn_id);

        const newSelectionsSend = allAccounts
          .filter(
            (account) =>
              account.beneficiary_account_approval_status === "approved" &&
              !selectedTransactions.includes(account.txn_id),
          )
          .slice(0, remainingSelections)
          .map((account) => account);

        setSelectedTransactions((prevSelected) => [
          ...prevSelected,
          ...newSelections,
        ]);

        setSelectedSendTransactions((prevSelected) => [
          ...prevSelected,
          ...newSelectionsSend,
        ]);

        const newAmounts = allAccounts
          .filter((account) => newSelections.includes(account.txn_id))
          .reduce((sum, account) => sum + Number(account.amount), 0);

        setTotalAmount((prevAmount) => prevAmount + newAmounts);
      } else {
        let x = [];
        approvedAccounts.map((itm) => {
          if (selectedTransactions.includes(itm.txn_id)) {
            x.push(itm.txn_id);
          }
        });
        let y = selectedTransactions.filter((it) => !x.includes(it));
        let z = selectedSendTransactions.filter(
          (itm) => !x.includes(itm.txn_id),
        );
        setSelectedTransactions(y);
        setSelectedSendTransactions(z);
        let amt = z.reduce((sum, account) => sum + Number(account.amount), 0);
        setTotalAmount(amt);
      }
    }
  };

  const handleSelect = (value) => {
    setSelectedValue(value);
    setPageSize(value);
    setPage(Number(page));
  };
  const handlePagination = (page) => {
    setPage(page);
  };

  const onMount = async ({
    pageNo = page,
    size = pageSize,
    categoryVal = currentCategory,
    labelsVal = LabelSearchText,
  } = {}) => {
    try {
      setAllBeneTxnAccountsLoading(true);

      const res = await dispatch(
        BeneTxnRequireApprovalPage({
          page_no: pageNo,
          page_size: size,
          category: categoryVal || undefined,
          labels: labelsVal?.length ? labelsVal : undefined,
        }),
      );

      const newData =
        res?.payload?.transactions?.map((txn) => ({
          ...txn,
          loading: false,
          error: "false",
          message: "",
        })) || [];

      setAllAccounts(newData);
      setMainData(res?.payload);
      setfilteredData(newData);

      const approved = newData.filter(
        (txn) => txn.beneficiary_account_approval_status === "approved",
      );
      setApprovedAccounts(approved);
    } catch (error) {
      console.error("Failed to fetch beneficiary transactions", error);
    } finally {
      setAllBeneTxnAccountsLoading(false);
    }
  };

  const fetchFilterData = async () => {
    let response;
    let data = [];
    setLoadingData(true);
    switch (active) {
      case "Category":
        response = await dispatch(
          beneCategories({ search_string: searchUserTextDebounce }),
        );
        data =
          response?.payload?.categories?.map((itm) => ({
            id: itm.name,
            Category: itm.name,
            Description: itm?.description || "Not given",
          })) || [];
        setInputData(data);
        setLoadingData(false);
        break;

      case "Labels":
        data = labels
          ?.filter((itm) => {
            if (itm.includes(searchUserTextDebounce)) return itm;
          })
          ?.map((val) => {
            return { id: val, Label: val };
          });
        setInputData(data);
        setLoadingData(false);
        break;

      default:
        setLoadingData(false);
        break;
    }
  };

  useEffect(() => {
    dispatch(enableSwitcher());
    return () => {
      dispatch(disableSwitcher());
    };
  }, []);

  useEffect(() => {
    onMount();
  }, [dispatch, currentCategory, LabelSearchText, page, pageSize, markerData]);

  useEffect(() => {
    if (active?.length) {
      fetchFilterData();
    }
  }, [active]);

  useEffect(() => {
    const handlefilter = (e) => {
      if (
        (filterRef.current && filterRef.current.contains(e.target)) ||
        (filterRefPagination.current &&
          filterRefPagination.current.contains(e.target))
      ) {
        setFilterOpen(false);
      }
    };
    document.addEventListener("click", handlefilter);
  }, [filterRef, filterRefPagination]);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Enter" && filterOpen) {
        handleFilterCategory();
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [label, selectedLabels, filterOpen]);

  useEffect(() => {
    const selectedCategory = currentCategory;
    setAllBeneTxnAccountsLoading(true);
    let availableLabels = sessionStorage?.getItem("AvailableLabelsTxn");
    const parsedLabels = JSON?.parse(availableLabels);
    settxnLabels(parsedLabels);

    dispatch(
      BeneTxnRequireApprovalPage({
        page_no: page,
        page_size: pageSize,
        category: selectedCategory !== "" ? selectedCategory : undefined,
        labels: LabelSearchText,
      }),
    )
      .then((response) => {
        const newData =
          response?.payload?.transactions?.map((account) => ({
            ...account,
            loading: false,
            error: "false",
            message: "",
          })) || [];

        setAllAccounts((prevAccounts) =>
          newData.length ? [...newData] : prevAccounts,
        );
        setMainData(response?.payload);
        setfilteredData(response?.payload?.transactions ?? []);
        setAllBeneTxnAccountsLoading(false);

        const approved = newData.filter(
          (account) =>
            account.beneficiary_account_approval_status === "approved",
        );
        setApprovedAccounts((prevApproved) => [...prevApproved, ...approved]);
        let availableLabels = sessionStorage?.getItem("AvailableLabelsTxn");
        const parsedLabels = JSON?.parse(availableLabels);
        setLabels(parsedLabels);
      })
      .catch(() => {
        setAllBeneTxnAccountsLoading(false);
      });
  }, [dispatch, currentCategory, LabelSearchText, page, pageSize]);

  useEffect(() => {
    if (label === "") {
      setCurrentCategory("");
    }
  }, [label]);

  return (
    <>
      {showTxnDetailPop ? (
        <div className="fixed top-top-base left-left-base w-screen h-screen flex items-center justify-center z-z-index-modal bg-PopUp-BackDrop bg-opacity-dark-opacity">
          <BeneTransactionDetailsPopup
            closeBeneTxnDetailModal={closeBeneTxnDetailModal}
            bene_txn_id={txnId}
            type="bene_txn_detail_modal"
            onReloadList={refreshBeneList}
          />
        </div>
      ) : null}
      {isDrawerOpen ? (
        <div className="fixed top-top-base left-left-base w-screen h-screen flex items-center justify-center z-z-index-modal bg-PopUp-BackDrop bg-opacity-dark-opacity">
          <BeneAccountDetailsPopup
            closeBeneAccountDetailModal={closeBeneAccountDetailModal}
            bene_account_id={BeneTxnDetailsId}
            beneAccountStatus={beneAccountStatus}
            type={"bene_account_detail_modal"}
          />
        </div>
      ) : null}
      <div
        className="bg-primary-bg flex flex-col h-screen relative overflow-hidden"
        style={{
          background: filterOpen ? "var(--PopUp-BackDrop)" : "",
        }}
      >
        <div className="w-width-full h-height-full">
          <div className="w-width-full h-height-full relative flex flex-col overflow-hidden ">
            <div className="w-width-full h-navbar-breadcrumb-height Qmd:block hidden bg-primary-nav flex-shrink-0"></div>
            <div className="z-z-index-overlay">
              <TopNavComponent
                ispagination={shouldShowPagination}
                topNavHeader={totalAmount}
                topNavSubText="Total amount"
                prevBalance={0}
                ownerAccBalanceLoading={false}
                BalanceStateRequired={true}
                AllPageRefresh={false}
                isSelectionView={true}
                selectionText={`Transactions selected : ${selectedTransactions.length}`}
                selectionBtnProps={
                  !shouldShowPagination
                    ? undefined
                    : {
                        btnText: "Select up to 20",
                        btnType: "button",
                        enabledBgColor:
                          selectedTransactions?.length <
                            GlobalConfiguration?.categorymaxLength &&
                          approvedAccounts.length !==
                            GlobalConfiguration?.lengthCheckZero &&
                          approvedAccounts.every((itm) =>
                            selectedTransactions.includes(itm.txn_id),
                          )
                            ? "var(--positive-bg)"
                            : selectedTransactions?.length ===
                                GlobalConfiguration?.categorymaxLength
                              ? "var(--positive-bg)"
                              : "var(--primary-nav-act)",
                        hoverOption:
                          selectedTransactions?.length <
                            GlobalConfiguration?.categorymaxLength &&
                          approvedAccounts.length !==
                            GlobalConfiguration?.lengthCheckZero &&
                          approvedAccounts.every((itm) =>
                            selectedTransactions.includes(itm.txn_id),
                          )
                            ? "black"
                            : selectedTransactions?.length ===
                                GlobalConfiguration?.categorymaxLength
                              ? "black"
                              : "white",
                        enabledTextColor: "var(--text-primary)",
                        icon:
                          selectedTransactions?.length <
                            GlobalConfiguration?.categorymaxLength &&
                          approvedAccounts.length !==
                            GlobalConfiguration?.lengthCheckZero &&
                          approvedAccounts.every((itm) =>
                            selectedTransactions.includes(itm.txn_id),
                          )
                            ? ICONS?.SELECTED_WITH_GREEN_CIRCLE
                            : selectedTransactions?.length ===
                                GlobalConfiguration?.categorymaxLength
                              ? ICONS?.SELECTED_WITH_GREEN_CIRCLE
                              : ICONS?.SELECT_ALL_WHITE_OUTLINE,
                        handleFunction: () => {
                          setselectAllCard(
                            approvedAccounts.every((itm) =>
                              selectedTransactions.includes(itm.txn_id),
                            )
                              ? true
                              : selectAllCard
                                ? false
                                : true,
                          );
                          handleSelectAll(
                            approvedAccounts.every((itm) =>
                              selectedTransactions.includes(itm.txn_id),
                            ),
                          );
                        },
                      }
                }
                topNavCtaBtn2Props={{
                  inActiveVariantNeeded: true,
                  btnText: "Next",
                  btnType: "button",
                  enabledBgColor: "var(--text-primary)",
                  enabledTextColor: "var(--primary-bg)",
                  isDisabled: !selectedTransactions?.length,
                  disabledBgColor: "var(--text-disabled)",
                  disabledTextColor: "var(--text-primary)",
                  handleFunction: () => {
                    if (
                      selectedTransactions?.length >=
                      GlobalConfiguration?.lengthCheckOne
                    ) {
                      const selectedData = {
                        selectedSendTransactions,
                        selectedTransactions,
                        timestamp: Date.now(),
                      };
                      sessionStorage.setItem(
                        "selectedData",
                        JSON.stringify(selectedData),
                      );
                      navigate(
                        "/beneficiary_transaction_dashboard/beneficiary_transaction_multi_approval/multi_approval",
                      );
                    }
                  },
                }}
                isToggleNeeded={true}
                toggleProps={{
                  state: false,
                  isDisabled: false,
                  title: "Single Approval",
                  handleClick: () =>
                    navigate(
                      "/beneficiary_transaction_dashboard/beneficiary_transaction_single_approval",
                    ),
                }}
                filteredSearchProps={{
                  setShowInnerSearchBar: setShowInnerSearchBar,
                  showSearchBar: showSearch,
                  isSearchDisabled: loadingData,
                  onSearchInput: handleSearch,
                  searchText: searchUserTextDebounce,
                  searchPlaceholder: "Search beneficiary transaction",
                  filterPlaceholder: "Search beneficiary transaction",
                  filterItems: [
                    {
                      name: "Category",
                      short_name: "Cat",
                      isMulti: false,
                      value: currentCategory,
                      setValue: (val) => {
                        setPage(1);
                        setCurrentCategory(val);
                      },
                      isDropdown: true,
                    },
                    {
                      name: "Labels",
                      short_name: "Lab",
                      isMulti: true,
                      value: LabelSearchText,
                      setValue: (val) => {
                        setPage(1);
                        setLabelSearchText(val);
                      },
                      isDropdown: true,
                    },
                  ],
                  isSearchClearAllDisabled: !(
                    currentCategory?.length || LabelSearchText?.length
                  ),

                  inputData: inputData,
                  active: active,
                  setActive: setActive,
                  loading: loadingData,
                  setLoading: setLoadingData,
                  isShowFilter: false,
                  isShowSortBy: false,
                }}
              />
            </div>

            <div
              className={`h-height-full flex flex-col overflow-hidden  bg-primary-bg ${
                allAccounts?.length == GlobalConfiguration.lengthCheckZero ||
                allBeneTxnAccountsLoading
                  ? "pb-bottom-base"
                  : "Qsmd:pb-[var(--pagination-height)] pb-topnav-bottom-height"
              } `}
            >
              {showInnerSearchBar && (
                <div className="absolute bg-PopUp-BackDrop opacity-dark-opacity w-full h-full z-z-index-header"></div>
              )}
              <div
                ref={filterRef}
                className="w-width-full overflow-y-auto h-[-webkit-fill-available]"
                style={{
                  overflow: filterOpen ? "hidden" : "auto",
                }}
              >
                {allBeneTxnAccountsLoading ? (
                  <div className="loader-container m-auto justify-center items-center flex h-height-full">
                    <Loader />
                  </div>
                ) : shouldShowEmptyState ? (
                  <div className="int-txn-mutli-no-account-found">
                    <div className="flex justify-center items-center">
                      <img
                        src={
                          (currentCategory?.length ||
                            LabelSearchText?.length) &&
                          !allAccounts?.length
                            ? "https://q2pay.in/new_assets/graphics/no_data/no_data_found.svg"
                            : "https://q2pay.in/new_assets/graphics/no_data/no_pending_transaction.svg"
                        }
                        alt={
                          ShowFilterErrorPage && !allAccounts?.length
                            ? "FiterNoAccount"
                            : "NoAccountFound"
                        }
                      />
                    </div>
                    <div className="int-txn-mutli-left-text-content-no-account">
                      {hasNoData && isFilterApplied && (
                        <>
                          <p className="text-font-md text-text-primary text-center">
                            No data found.
                          </p>
                          <div className="mt-margin-sm">
                            <PrimaryButton
                              btnText="Clear parameters"
                              handleFunction={handleClearParams}
                              enabledBgColor="var(--primary-nav-act)"
                              enabledTextColor="var(--text-primary)"
                              hoverOption="white"
                            />
                          </div>
                        </>
                      )}

                      {hasNoData && !isFilterApplied && (
                        <>
                          <p className="text-font-md text-text-primary text-center">
                            There are no more transactions that require <br />
                            your approval.
                          </p>
                          <div className="mt-margin-sm">
                            <PrimaryButton
                              btnText="Beneficiary transaction dashboard"
                              handleFunction={() =>
                                navigate("/beneficiary_transaction_dashboard")
                              }
                              enabledBgColor="var(--primary-nav-act)"
                              enabledTextColor="var(--text-primary)"
                              hoverOption="white"
                            />
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                ) : (
                  <>
                    {allAccounts?.length ? (
                      <>
                        <div
                          className={`${
                            filterOpen
                              ? "pointer-events-none"
                              : "flex flex-col flex-1 items-center justify-center mx-auto"
                          }`}
                          style={{
                            scrollPaddingTop: "var(--padding-md)",
                            scrollPaddingBottom: "var(--padding-md)",
                          }}
                        >
                          <BeneTransactionMultiApprovalCard
                            filterRef={filterRef}
                            filterOpen={filterOpen}
                            setAllAccounts={setAllAccounts}
                            data={allAccounts}
                            selectedTransactions={selectedTransactions}
                            setSelectedTransactions={setSelectedTransactions}
                            totalAmount={totalAmount}
                            setselectAllCard={setselectAllCard}
                            setTotalAmount={setTotalAmount}
                            selectedSendTransactions={selectedSendTransactions}
                            setSelectedSendTransactions={
                              setSelectedSendTransactions
                            }
                            SetBeneTxnDetailsId={SetBeneTxnDetailsId}
                            setBeneAccountStatus={setBeneAccountStatus}
                            setTxnId={setTxnId}
                            openBeneTxnDetailModal={openBeneTxnDetailModal}
                            isDrawerOpen={isDrawerOpen}
                            setisDrawerOpen={setisDrawerOpen}
                          />
                        </div>
                      </>
                    ) : null}
                  </>
                )}
              </div>
            </div>
            <div
              className={`flex flex-col absolute bottom-bottom-base ${showInnerSearchBar ? "opacity-light-opacity bg-PopUp-BackDrop pointer-events-none" : "opacity-base-opacity"}`}
            >
              {shouldShowPagination && (
                <div className="z-z-index-fixed-ui w-screen">
                  <PaginationComponent
                    handleSelect={handleSelect}
                    selectedValue={selectedValue}
                    data={mainData}
                    pageSize={pageSize}
                    dropdownOptions={dropdownOptions}
                    handlePagination={handlePagination}
                    currentPage={page}
                    setIsOpen={setIsOpen}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default BeneficiaryTransactionMultiSelect;
